import React from 'react';
import { useSelector } from 'react-redux';
import { DomHelpers, StringHelpers, SystemText } from 'e4shared';
import Bullet from '../bullet';

export const Metric = ({ metric, loading, period, noShadow }) => {
    const [explainer, setExplainer] = React.useState('');
    const user = useSelector(state => state.user.user);
    const loaded = React.useRef(null);
    const infinite = metric.change === -2147483648;

    const resizeHandler = () => {
        const containers = document.getElementsByClassName('prism-metric-score-value');
        [...containers].map(x => DomHelpers.shrinkFont('label-text-fit', 32, x));
    };

    React.useEffect(() => {
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    React.useEffect(() => {
        if (loaded?.current) {
            resizeHandler();
        }
    }, [loaded?.current, loading]);

    const text = {
        infoWeek: SystemText('Welcome/Metrics/InfoWeek'),
        infoMonth: SystemText('Welcome/Metrics/InfoMonth'),
        infoQuarter: SystemText('Welcome/Metrics/InfoQuarter'),
    };

    React.useEffect(() => {
        switch (period) {
            case 'W':
                setExplainer(text.infoWeek);
                break;
            case 'M':
                setExplainer(text.infoMonth);
                break;
            case 'Q':
                setExplainer(text.infoQuarter);
                break;
        }
    }, [period]);

    return (
        <div
            ref={loaded}
            data-testid="metric-item"
            key={`metric-${metric.id}`}
            className={`prism-metric ${noShadow ? 'no-shadow' : ''}`}
        >
            <div className="prism-metric-name">{metric.name}</div>
            {loading ? (
                <i className="fa fa-spinner fa-spin" />
            ) : (
                <div className="prism-metric-score">
                    <div className="prism-metric-score-value" style={{ overflow: 'hidden' }}>
                        <span className="label-text-fit">
                            {StringHelpers.formatMetric(metric.format, metric.value, user.currencySymbol)}
                        </span>
                    </div>
                    <Bullet
                        icon={infinite || metric.change >= 0 ? 'arrow-up' : 'arrow-down'}
                        value={infinite ? ' ' : `${metric.change >= 0 ? metric.change : metric.change * -1}%`}
                        style={infinite || metric.change >= 0 ? 'positive round' : 'negative round'}
                    />
                </div>
            )}
            <div className="mt10">{explainer}</div>
        </div>
    );
};

export default Metric;
